import React, { FC } from 'react';
import { Tooltip } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { formatVideoFileSize } from './videoDetails';

export const FILE_SIZE_INFO = 'This is the size of the original HD version. Optimized versions may be smaller.';

/**
 * The probed `s3_files.file_size` with an (i) explaining which file it
 * measures — the iconik source, not the optimized copies people stream or
 * download. Renders nothing when the size is unknown. The icon sizes with the
 * surrounding text and stops clicks so a tap on a card's (i) doesn't open it.
 */
export const FileSizeSpec: FC<{ size?: number | string | null }> = ({ size }) => {
  const label = formatVideoFileSize(size);
  if (!label) return null;
  return (
    <span className="inline-flex items-center gap-1 tabular-nums">
      {label}
      <Tooltip title={FILE_SIZE_INFO} arrow placement="top">
        <span
          className="inline-flex items-center cursor-help"
          aria-label={FILE_SIZE_INFO}
          onClick={(e) => e.stopPropagation()}
        >
          <InfoOutlinedIcon sx={{ fontSize: '1.1em', opacity: 0.75 }} />
        </span>
      </Tooltip>
    </span>
  );
};
